import type {
  AttributeType,
  SubjectType,
  SplitOption,
  SubjectEditor
} from '@aytm/app/insights/dashboard/models/types.ClientDTO'

import BlockModel from '@aytm/app/insights/dashboard/models/BlockModel'
import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import { compareTuples } from '@aytm/app/insights/dashboard/lib/comparison'
import { getPortalFilters } from '@aytm/app/insights/dashboard/helpers/filters'

export type StateSelectorParams = {
  blockModel: BlockModel | null
  subjects: Record<string, SubjectType>
  attributes: Record<string, AttributeType>
  splitOptions: SplitOption[]
  selectedSubjects: number
  dataFetched: boolean
  serverError: string | null
  editor: SubjectEditor | null
  itemFrom: number
  itemTo: number
  editorMode: boolean
  isSharedView: boolean
  hasPportalFilters: boolean
  subjectType: string
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const blockModel = getCurrentBlock(state)
  const subjects = state.currentData?.subjects || {}
  const attributes = state.currentData?.attributes || {}
  const splitOptions = state.currentData?.splitOptions || []
  const selectedSubjects = state.currentData?.selectedSubjects ?? 0
  const dataFetched = state.currentData?.dataFetched || false
  const serverError = state.currentData?.serverError || null
  const editor = state.editor || null
  const itemFrom = state.itemFrom ?? -1
  const itemTo = state.itemTo ?? -1
  const roles = state.accessKey?.roles || []
  const editorMode = roles && roles.includes('editor')
  const isSharedView = state.isSharedView || false
  const portalModelFilters = getPortalFilters(state)
  const subjectType = blockModel?.getSubjectType() || ''
  return {
    blockModel,
    subjects,
    attributes,
    splitOptions,
    selectedSubjects,
    dataFetched,
    serverError,
    editor,
    itemFrom,
    itemTo,
    editorMode,
    isSharedView,
    hasPportalFilters: portalModelFilters?.size > 0,
    subjectType
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : (!prev && Boolean(next)) ||
      (Boolean(prev) && !next) ||
      !compareTuples(
        ({
          blockModel,
          subjects,
          attributes,
          splitOptions,
          selectedSubjects,
          dataFetched,
          serverError,
          editor,
          itemFrom,
          itemTo,
          editorMode,
          isSharedView,
          filteredRowAverages
        }) => [
          blockModel,
          subjects,
          attributes,
          splitOptions,
          selectedSubjects,
          dataFetched,
          serverError,
          editor,
          itemFrom,
          itemTo,
          editorMode,
          isSharedView,
          filteredRowAverages
        ]
      )(prev, next)
